const yellowPalette = {
  main: '#E2D18F',
  light: '#FFFBE0',
  dark: '#CCA542'
};

export default yellowPalette;